import { useRequest } from '@polvo-labs/react-auth'
import React, { useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Button from '../../Button'
import Icon from '../../Icon'
import Loader from '../../Loader'
import Modal from '../../Modal'
import { MessageCreate, Upload } from '../type'
import { Actions, ImageContainer, ModalContent as Container } from './styles'


interface Props {
  onChange: (message: MessageCreate) => void
}

const Image: React.FC<Props> = ({ onChange }) => {
  const [open, setOpen] = useState(false)
  const [image, setImage] = useState<Upload>()
  const { request } = useRequest()
  const [uploading, setUploading] = useState(false)
  const ref = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (ref && ref.current) {
      const input = ref.current

      if (input) {
        input.click()
      }
    }
  }

  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length === 1) {
      if (event.target.files[0].size > 20000000) {
        toast.error('Arquivo não deve exceder 20MB de tamanho.')
        return
      }
      const formData = new FormData()
      formData.append('files[]', event.target.files[0])
      setUploading(true)
      request({
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/chat/uploads`,
        data: formData,
      }).then(({ data }) => {
        toast.info('Upload realizado com sucesso')
        setUploading(false)
        if (data && data.data) {
          setImage(data.data[0])
        }
      }).catch(() => {
        toast.error('Ocorreu um erro ao fazer o upload')
        setUploading(false)
      })
    }
  }

  return (
    <>
      <Button
        before={(
          <Icon
            name="image"
          />
        )}
        label="Escolher uma foto"
        backgroundColor="transparent"
        fontColor="darkGray"
        smallPadding
        alignText="flex-start"
        onClick={() => setOpen(true)}
      />

      <Modal
        open={open}
        onToggle={open => {
          setImage(undefined)
          setOpen(open)
        }}
      >
        <Container>
          <input
            type="file"
            ref={ref}
            accept="image/*"
            hidden
            onChange={handleFile}
          />

          {image && (
            <ImageContainer>
              <img
                src={image.small}
                alt=""
              />
            </ImageContainer>
          )}

          {image ? (
            <Actions>
              <Button
                label="REMOVER FOTO"
                backgroundColor="red"
                onClick={() => {
                  const input = ref.current as unknown as HTMLInputElement
                  input.value = ''
                  setImage(undefined)
                }}
              />

              <Button
                label="ESCOLHER FOTO"
                onClick={() => {
                  onChange({
                    type: 'IMAGE',
                    upload: image,
                  })
                  setOpen(false)
                }}
              />
            </Actions>
          ) : (
              <Button
                label="SELECIONAR FOTO"
                onClick={handleClick}
              />
            )}
        </Container>

        {uploading && (
          <Loader
            delay={0}
            full
          />
        )}
      </Modal>
    </>
  )
}

export default Image
